import { totalFixedFees, totalRecurringFee } from '~/bonus/helpers/bonus.helpers'
import { BonusType } from '~/bonus/model/bonus.model'
import { formatFee, formatAmount } from '~/utils'

export default function formatBonusFee(bonus: BonusType) {
  if (bonus.recurringFee?.valueWithTax) {
    return bonus.duration > 1
      ? `${formatFee(totalFixedFees(bonus))} + ${formatAmount(totalRecurringFee(bonus), 2)}€ al mes`
      : formatFee(totalFixedFees(bonus) + bonus.recurringFee.valueWithTax)
  }

  return formatFee(totalFixedFees(bonus))
}

export function formatBonusNameAndPrice(bonus: BonusType) {
  const { name } = bonus
  const price = formatBonusFee(bonus)

  return `${name} (${price})`
}

export function getTotalPrice(bonuses: BonusType[]) {
  const totalPrice = bonuses.reduce(
    (acc, bonus) => acc + totalRecurringFee(bonus) + totalFixedFees(bonus),
    0,
  )

  return totalPrice
}

export function getSelectedBonus(bonuses: BonusType[], bonusesIds: string[]) {
  return bonuses.filter((bonus) => bonusesIds.includes(bonus.id))
}
